/* 实名认证 */
<template>
  <div class="my-personl">
    <div
      class="successPersonal"
      v-if="
        isVerified && info && info.realAuthStatus === 2 && activeIndex === 0
      "
    >
      <div class="successImg">
        <img src="../../../../../images/succseeAUsset.png" alt />
      </div>
      <p class="successText">恭喜你 认证成功！</p>
      <Row
        class="successDetail"
        type="flex"
        justify="center"
        align="middle"
        :gutter="40"
      >
        <Col span="12" style="text-align:right;">真实姓名：</Col>
        <Col span="12" style="text-align:left;">{{
          formMyPersonal.realName
        }}</Col>
      </Row>
      <Row
        class="successDetail successDetailNext"
        type="flex"
        justify="center"
        align="middle"
        :gutter="40"
      >
        <Col span="12" style="text-align:right;">证件类型：</Col>
        <Col span="12" style="text-align:left;">身份证</Col>
      </Row>
      <Row
        class="successDetail successDetailNext"
        type="flex"
        justify="center"
        align="middle"
        :gutter="40"
      >
        <Col span="12" style="text-align:right;">证件号：</Col>
        <Col span="12" style="text-align:left;">{{
          formMyPersonal.idNumber
        }}</Col>
      </Row>
    </div>
    <Form
      ref="formMyPersonal"
      :rules="ruleMyPersonal"
      :model="formMyPersonal"
      label-position="left"
      :label-width="100"
    >
      <!-- v-if="formMyPersonal.type === '1'" -->
      <div v-if="!(isVerified && info && info.realAuthStatus === 2)">
        <FormItem
          v-if="activeIndex === 0"
          label="真实姓名"
          style="width:350px;"
          prop="realName"
        >
          <Input
            :disabled="isVerified && info.realAuthStatus === 2"
            v-model="formMyPersonal.realName"
            :maxlength="15"
            placeholder="请输入真实的姓名"
          ></Input>
        </FormItem>

        <!-- <FormItem v-if="activeIndex === 0" label="证件类型" style="width:350px;" prop="idStyles">
          <Select
            class="idStyles"
            :disabled="isVerified && info.realAuthStatus === 2"
            v-model="formMyPersonal.idStyles"
            placeholder="请输入身份证号码"
          >
            <Option
              style="text-aligin:left;"
              v-for="item in stylesLists"
              :value="item.value"
              :key="item.value"
            >{{ item.label }}</Option>
          </Select>
        </FormItem> -->

        <FormItem
          v-if="activeIndex === 0"
          label="证件号"
          style="width:350px;"
          prop="idNumber"
        >
          <Input
            :disabled="isVerified && info.realAuthStatus === 2"
            v-model="formMyPersonal.idNumber"
            :maxlength="50"
            placeholder="请输入身份证号码"
          ></Input>
        </FormItem>
      </div>

      <div
        v-if="activeIndex === 1 && (!isCompanyVerified || isAddAuth)"
        class="animated fast fadeIn"
      >
        <FormItem style="width:600px;text-align:left;" class="check-box">
          <div v-if="disabledDetails && formMyPersonal.rejectReason">
            <p>失败原因：</p>
            <p style="color: #4A4A4A">{{ formMyPersonal.rejectReason }}</p>
          </div>
        </FormItem>

        <FormItem label="企业名称" style="width:600px;" prop="companyName">
          <Input
            :disabled="disabledDetails && !formMyPersonal.rejectReason"
            v-model="formMyPersonal.companyName"
            :maxlength="50"
            placeholder="请输入企业名称"
          ></Input>
        </FormItem>
        <FormItem label="法人姓名" style="width:600px;" prop="legalPerson">
          <Input
            :disabled="disabledDetails && !formMyPersonal.rejectReason"
            v-model="formMyPersonal.legalPerson"
            :maxlength="20"
            placeholder="请输入法人姓名"
          ></Input>
        </FormItem>
        <FormItem label="统一社会信用代码" style="width:600px;" prop="regCode">
          <Input
            :disabled="disabledDetails && !formMyPersonal.rejectReason"
            v-model="formMyPersonal.regCode"
            :maxlength="50"
            placeholder="请输入统一社会信用代码"
          ></Input>
        </FormItem>
        <FormItem label="经办人姓名" style="width:600px;" prop="agent">
          <Input
            :disabled="disabledDetails && !formMyPersonal.rejectReason"
            v-model="formMyPersonal.agent"
            :maxlength="20"
            placeholder="请输入经办人姓名"
          ></Input>
        </FormItem>

        <FormItem
          label="经办人身份证号"
          style="width:600px;"
          prop="idNumber_02"
        >
          <Input
            :disabled="disabledDetails && !formMyPersonal.rejectReason"
            v-model="formMyPersonal.idNumber_02"
            :maxlength="50"
            placeholder="请输入经办人身份证号"
          ></Input>
        </FormItem>
        <FormItem label="企业认证委托授权书" style="width:600px;">
          <Row
            :gutter="16"
            type="flex"
            class="attorney-row"
            justify="start"
            align="top"
          >
            <Col span="12">
              <div class="attorney">
                <z-upload
                  v-show="!formMyPersonal.evidenceMaterialFile"
                  v-if="Object.keys(ossKeys).length > 0"
                  :type="17"
                  @success="successHandle"
                  :maxSize="5120"
                  :ossKey="ossKeys"
                  :progressBar="true"
                >
                  <div>
                    <i class="iconfont icon-camera1"></i>
                    <p>上传企业委托授权书</p>
                  </div>
                </z-upload>
                <img
                  v-if="formMyPersonal.evidenceMaterialFile"
                  :src="imgBaseUrl + formMyPersonal.evidenceMaterialFile.key"
                  alt
                />
              </div>
            </Col>
            <Col
              span="12"
              v-if="!disabledDetails || formMyPersonal.rejectReason"
            >
              <div class="attorney">
                <z-panelimg
                  :del="false"
                  width="217"
                  height="165"
                  :src="entrustment"
                ></z-panelimg>
                <a
                  target="_blank"
                  href="https://oss.zhulogic.com/doc/20190514.doc"
                >
                  <span class="download">下载委托书模板</span>
                </a>
              </div>
            </Col>
          </Row>
        </FormItem>

        <FormItem
          class="check-box"
          v-if="!disabledDetails || formMyPersonal.rejectReason"
          style="width:800px;margin-top:80px;text-align:left;"
          prop="single"
        >
          <Checkbox v-model="formMyPersonal.single"
            >我保证上传的图片没有法律纠纷，我对因虚假资料或图片版权引起的法律纠纷负全部责任。</Checkbox
          >
        </FormItem>
      </div>

      <!-- v-if="activeIndex === 0" -->
      <div
        style="width:880px;"
        v-if="activeIndex === 1 && isCompanyVerified && !isAddAuth"
      >
        <company-lists
          @addAuth="addAuth"
          @details="checkDetails"
          @deleteCompany="deleteCompany"
          :companyAuthLists="companyAuthLists"
        ></company-lists>
      </div>

      <FormItem
        class="personal-margin-left"
        style="margin-bottom:150px;margin-top:50px;"
      >
        <Row :gutter="30" type="flex" align="middle" style="margin-top:10px;">
          <Col
            span="7"
            v-if="activeIndex === 1 && isAddAuth && isCompanyVerified"
          >
            <Button @click="cencelHandle" long>取消</Button>
          </Col>
          <Col span="7" v-if="activeIndex === 0">
            <Button
              v-if="!(isVerified && info.realAuthStatus === 2)"
              :disabled="isVerified && info.realAuthStatus === 2"
              type="primary"
              :loading="loading"
              @click="submit"
              long
              >{{
                isVerified && info.realAuthStatus === 2 ? "已完成认证" : "提交"
              }}</Button
            >
          </Col>

          <Col span="7" v-if="activeIndex === 1 && formMyPersonal.rejectReason">
            <Button type="primary" :loading="loading" @click="companyAgain" long
              >重新提交</Button
            >
          </Col>

          <Col
            style="margin-left:30px;"
            span="7"
            v-if="
              activeIndex === 1 &&
                !(isCompanyVerified && !isAddAuth) &&
                !disabledDetails
            "
          >
            <Button type="primary" :loading="loading" @click="submit" long
              >提交</Button
            >
          </Col>
        </Row>
      </FormItem>
    </Form>
  </div>
</template>
<script>
import _ from "lodash";
import api from "../../../../../api/index";
import companyLists from "./companyLists";
import entrustment from "../../../../../images/user/entrustment1.png";
export default {
  data() {
    const validateLoginName = (rule, value, callback) => {
      if (value === "" || value === undefined) {
        callback(new Error("此内容为必填项"));
      }
      callback();
    };
    const validateIdentity = (rule, value, callback) => {
      if (value === "" || value === undefined) {
        callback(new Error("此内容为必填项"));
      } else {
        if (
          !/^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(
            value
          )
        ) {
          callback(new Error("请输入正确身份证号码"));
        }
      }
      callback();
    };
    const validateCompanyName = (rule, value, callback) => {
      if (value === "" || value === undefined) {
        callback(new Error("此内容为必填项"));
      }
      callback();
    };
    const validateRegCode = (rule, value, callback) => {
      if (value === "" || value === undefined) {
        callback(new Error("此内容为必填项"));
      } else {
        if (!/^[0-9a-zA-Z]+$/.test(value)) {
          callback(new Error("只允许输入英文字母和数字"));
        }
      }
      callback();
    };

    const validatesingle = (rule, value, callback) => {
      if (!value) {
        callback("您必须勾选此协议, 才能进行认证！");
      }
      callback();
    };
    return {
      imgBaseUrl: api.common.imgBaseUrl,
      entrustment: entrustment,
      loading: false,
      ossKeys: {},
      isVerified: false, // 个人是否已经实名认证
      isCompanyVerified: false,
      isAddAuth: false, // 是否新增企业实名
      disabledDetails: false, // 是否在查看详情
      companyAuthLists: [], // 企业认证列表
      formMyPersonal: {
        realName: "",
        idNumber: "",
        // idStyles: 1,
        type: "1",

        single: false,
        channel: 1, //渠道
        companyName: "", //企业名称
        agent: "", // 经办人姓名
        evidenceMaterialFile: "", //企业授权委托书
        idNumber_02: "", //经办人/法人身份证号
        legalPerson: "", //法人姓名
        regCode: "" // 统一社会信用代码
      },
      // stylesLists: [
      //   {
      //     label: "身份证",
      //     value: 1
      //   },
      //   {
      //     label: "护照",
      //     value: 2
      //   },
      //   {
      //     label: "台湾居民来往大陆通行证",
      //     value: 3
      //   },
      //   {
      //     label: "港澳居民来往大陆通行证",
      //     value: 4
      //   }
      // ],
      ruleMyPersonal: {
        realName: [
          { required: true, validator: validateLoginName, trigger: "blur" }
        ],
        idNumber: [
          { required: true, validator: validateIdentity, trigger: "blur" }
        ],

        single: [{ validator: validatesingle, trigger: "blur" }],
        agent: [{ validator: validateCompanyName, trigger: "blur" }],
        companyName: [{ validator: validateCompanyName, trigger: "blur" }],
        regCode: [{ validator: validateRegCode, trigger: "blur" }],
        idNumber_02: [{ validator: validateIdentity, trigger: "blur" }],
        legalPerson: [{ validator: validateLoginName, trigger: "blur,change" }]
      }
    };
  },
  props: {
    info: {
      type: Object,
      default: function() {
        return {};
      }
    },
    activeIndex: {
      type: [String, Number],
      default: 0
    }
  },
  components: {
    companyLists
  },
  methods: {
    /* 提交认证上传 */
    submit() {
      this.$refs["formMyPersonal"].validate(valid => {
        if (valid) {
          if (this.activeIndex === 0) {
            /* 个人实名认证 */
            this.personal();
          } else {
            this.company();
          }
        } else {
          this.$Message.error("请把信息填写完整!");
        }
      });
    },
    /* 企业认证重新提交 */
    companyAgain() {
      this.$refs["formMyPersonal"].validate(valid => {
        if (valid) {
          this.company("again");
        } else {
          this.$Message.error("请把信息填写完整!");
        }
      });
    },
    /* 个人实名认证 */
    personal() {
      this.loading = true;
      let newObj = _.pick(this.formMyPersonal, ["realName", "idNumber"]);
      api.authNext
        .auth_personal(newObj)
        .then(res => {
          this.$store.dispatch("getUser");
          this.auth_personal_details();
          this.$Message.success("恭喜你，实名认证成功！");
          this.loading = false;
          // this.$router.push({path: '/my/personal/accountSetting?index=2'})
        })
        .catch(err => {
          this.loading = false;
        });
    },
    /* 公司实/企业认证 */
    company(again = null) {
      if (!this.formMyPersonal.evidenceMaterialFile) {
        this.$Message.warning("请上传企业认证委托授权书");
        return false;
      }
      this.loading = true;
      let newObj = _.pick(this.formMyPersonal, [
        "channel",
        "agent",
        "companyName",
        "evidenceMaterialFile",
        "idNumber_02",
        "legalPerson",
        "regCode"
      ]);

      let nextObj = _.assign(newObj, { idNumber: newObj.idNumber_02 }),
        post_ajax;
      if (!again) {
        post_ajax = api.authNext.auth_company;
      } else {
        nextObj.id = this.formMyPersonal.id;
        post_ajax = api.authNext.auth_company_again;
      }
      post_ajax(nextObj)
        .then(res => {
          this.$Message.success("恭喜你，企业认证提交成功，请耐心等待审核！");
          this.auth_company_details();
          this.cencelHandle();
          this.loading = false;
        })
        .catch(err => {
          // this.cencelHandle();
          this.loading = false;
        });
    },

    getOssKey(type) {
      api.files.uploadUrl(type).then(res => {
        this.ossKeys = res;
      });
    },

    /* 上传企业委托授权书 */
    successHandle(file) {
      this.formMyPersonal.evidenceMaterialFile = file.data[0];
    },

    /* 添加企业实名 */
    addAuth() {
      this.isAddAuth = true;
      Object.assign(this.formMyPersonal, {
        single: false,
        channel: 1, //渠道
        companyName: "", //企业名称
        agent: "",
        evidenceMaterialFile: "", //企业授权委托书
        idNumber_02: "", //经办人/法人身份证号
        legalPerson: "", //法人/经办人姓名
        regCode: "" // 统一社会信用代码
      });
    },

    /* 查看企业认证详情 */
    checkDetails(item) {
      this.isAddAuth = true;
      this.disabledDetails = true;
      Object.assign(this.formMyPersonal, item);
    },

    /* 个人认证详情 */
    auth_personal_details() {
      api.authNext.auth_personal_details().then(res => {
        if (res.idNumber) {
          this.isVerified = true;
          this.formMyPersonal.realName = res.realName;
          this.formMyPersonal.idNumber = res.idNumber;
        }
      });
    },

    /* 企业认证列表、详情 */
    auth_company_details() {
      api.authNext.auth_company_details().then(res => {
        if (res && res.length > 0) {
          this.isCompanyVerified = true;
          this.companyAuthLists = res;
          this.companyAuthLists.forEach(item => {
            item.idNumber_02 = item.idNumber;
          });
        }
      });
    },
    cencelHandle() {
      this.isAddAuth = false;
      this.disabledDetails = false;
      this.formMyPersonal.rejectReason = "";
    },

    /* 删除企业认证 */
    deleteCompany(item) {
      this.$Modal.confirm({
        title: "提示",
        loading: true,
        loading: true,
        content: "是否确认删除?",
        onOk: () => {
          api.authNext.delete_company(item.id).then(res => {
            this.$Message.success("删除成功");
            this.auth_company_details();
             this.$Modal.remove()
          });
        }
      });
    }
  },
  created() {
    this.getOssKey(17);
    this.auth_personal_details();
    this.auth_company_details();
  }
};
</script>

<style lang="scss">
.my-personl {
  .attorney-row {
    margin-top: 13px;
  }
  .attorney {
    height: 165px;
    background: rgba(234, 234, 234, 1);
    border-radius: 4px;
    text-align: center;
    i {
      display: inline-block;
      margin-top: 50px;
      color: #a6a6a6;
      font-size: 20px;
    }
    p {
      text-align: center;
      font-size: 12px;
    }
    .ivu-upload-drag {
      height: 165px;
      background: rgba(234, 234, 234, 1);
    }
    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
    .download {
      margin-top: 10px;
      color: #ff7668;
      cursor: pointer;
      display: inline-block;
      margin-left: 125px;
    }
  }
  .choiced {
    .ivu-form-item-content {
      margin-left: 0px !important;
    }
  }
  .check-box {
    .ivu-form-item-content {
      margin-left: 0px !important;
    }
  }
  .idStyles {
    .ivu-select-selected-value {
      text-align: left;
    }
    .ivu-select-item {
      text-align: left;
    }
  }
  .successPersonal {
    background: #fff;
    padding: 50px;
    text-align: center;
    width: 890px;
    padding-top: 0px;
    .successImg {
      margin: 0 auto;
      width: 200px;
      img {
        width: 100%;
      }
    }
    .successText {
      font-weight: 500;
      font-size: 18px;
      color: #6bc9ff;
    }
    .successDetail {
      margin-top: 80px;
      .ivu-col {
        font-size: 16px;
      }
    }
    .successDetailNext {
      margin-top: 22px;
    }
  }
}
</style>
